import i18n from '@/i18n'

// Help pages on the public kennisbank (keyvue.app), per app locale. Keep every in-app help link here,
// so the next restructure of the site is a change in one file. Anchors come from the article headings.
export type KnowledgeBasePage = 'index' | 'realworksLeads'

const pages: Record<'nl' | 'en', Record<KnowledgeBasePage, string>> = {
    nl: {
        index: 'https://keyvue.app/nl/kennisbank',
        realworksLeads: 'https://keyvue.app/nl/kennisbank/hoe-keyvue-werkt#leads-uit-realworks',
    },
    en: {
        index: 'https://keyvue.app/en/knowledge-base',
        realworksLeads: 'https://keyvue.app/en/knowledge-base/how-keyvue-works#leads-from-realworks',
    },
}

// The locale is fixed per build (VUE_APP_I18N_LOCALE); nl-NL and nl-BE get the Dutch pages too
export const knowledgeBaseUrl = (page: KnowledgeBasePage): string => {
    return (i18n.locale.startsWith('nl') ? pages.nl : pages.en)[page]
}
